import React from "react";
import IconButton from "@mui/material/IconButton";
import Button from "react-bootstrap/Button";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { Container, Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Grow from "@mui/material/Grow";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Multiselect from "multiselect-react-dropdown";
import PopupTemplate from "../components/PopupTemplate/PopupTemplate";
import { useForm } from "react-hook-form";
import PartnerEditMarket from "./PartnerEditMarket";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { Link, useParams } from "react-router-dom";
import { hardDeleteMarket } from "../../API/endpoints/Market";

interface MarketFromInputs {
  market: number;
  services: any[];
  engagement_model: any[];
  exclusivity: number;
  minimum_tenure: number;
  shipment_terms: [];
  category_focus: [];
  payment_terms: [];
  investments: number;
  remarks: "";
}

const PartnerDropDown = (props: any) => {
  const {
    onEditItem,
    onDeleteItem,
    marketID,
    countryID = -1,
    mode = "ADD",
    reviewOnly = false,
    partnerID = "",
    country = "",
    brandName = "",
    marketData,
    reload,
    haveDueDiligence = true,
    setOpenEditMarket = {}
  } = props;

  const params = useParams();
  const [open, setOpen] = React.useState(false);
  const [openDeleteMarket, setOpenDeleteMarket] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
    clearErrors,
  } = useForm<MarketFromInputs>();

  const handleCloseEditMarket = () => {
    setOpenEditMarket({});
  };

  const handleToggle = (e: any) => {
    e.stopPropagation();
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    event.stopPropagation();
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  const handleEdit = (event: Event | React.SyntheticEvent) => {
    event.stopPropagation();
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setOpen(false);
    console.log(marketData, "marketData");
    // setOpenEditMarket(true);
    onEditItem
      ? onEditItem(countryID ? countryID : marketID, !Boolean(onDeleteItem))
      : setOpenEditMarket(marketData);
  };

  // ----------------Delete Market----------------------
  const handleDelete = (event: Event | React.SyntheticEvent) => {
    event.stopPropagation();
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    if (props?.onDeleteItem) {
      onDeleteItem(marketID);
    } else {
      setOpen(false);
      setOpenDeleteMarket(true);
    }
  };

  const handleCloseDeleteMarketModal = () => {
    setOpenDeleteMarket(false);
  };

  const deleteItem = () => {
    hardDeleteMarket(marketID)
      .then(async (res) => {
        setOpenDeleteMarket(false);
        reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onHandleSuccessEditMarket = () => {
    reload();
    handleCloseEditMarket();
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    // if (event.key === "Tab") {
    //   event.preventDefault();
    //   setOpen(false);
    // } else if (event.key === "Escape") {
    //   setOpen(false);
    // }
  }
  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <div style={{pointerEvents: "none"}}>
      <>
        <IconButton
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <MoreHorizIcon
            sx={{
              pointerEvents: "auto",
            }}
          />
        </IconButton>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper sx={{ fontsize: "12px" }}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                    sx={{
                      pointerEvents: "auto",
                    }}
                  >
                    {reviewOnly ? (
                      <MenuItem sx={{ fontsize: "12px" }}>
                        <Link
                          to={`/DueDiligence/${brandName}/${partnerID}/${country}/${marketID}/view`}
                        >
                          Review Due Diligence
                        </Link>
                      </MenuItem>
                    ) : (
                      <>
                        <MenuItem
                          sx={{ fontsize: "12px" }}
                          onClick={handleEdit}
                        >
                          Edit
                        </MenuItem>
                        {haveDueDiligence && (
                          <MenuItem sx={{ fontsize: "12px" }}>
                            <Link to={`/DueDiligence/${params?.partnerId}`}>
                              Due Diligence
                            </Link>
                          </MenuItem>
                        )}

                        <MenuItem
                          sx={{ fontsize: "12px", color: "#F04438" }}
                          onClick={handleDelete}
                        >
                          Delete
                        </MenuItem>
                      </>
                    )}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
      {/* <PartnerEditMarket
        marketData={marketData}
        open={openEditMarket}
        onClose={handleCloseEditMarket}
        partnerID={partnerID}
        onSuccess={onHandleSuccessEditMarket}
      /> */}
      {/* -------------------------------------------------------------- */}
      <PopupTemplate
        popupHeader="Confirm Market Deletion"
        popupBody="Are you sure you want to delete market ?"
        handleFunction={deleteItem}
        isModalOpen={openDeleteMarket}
        onCancel={handleCloseDeleteMarketModal}
        id={marketID}
      />
    </div>
  );
};

export default PartnerDropDown;
